module.exports = __webpack_public_path__ + "img/D202104_4.938150a6.jpg";